// Package Imports
import { Col, Form, Row } from 'antd';
import { useTranslate } from '@refinedev/core';
import { SaveButton } from '@refinedev/antd';
// Project Imports
import TextInput from 'components/text/textInput';
import TextAreaInput from 'components/textarea/textAreaInput';
import constants from 'core/constants/Constants';
import RangeInput from 'components/date/rangeInput';
import SegmentInput from 'components/segment/SegmentInput';
// import CustomBadge from 'components/badge/badge';
import DropdownInput from 'components/dropdown/dropDownInput';
import useRulesDropdown from 'pages/rules/RulesDropdown';
import disabledDate from 'core/utils/disabledDate';

import regex from 'core/constants/Regex';
import { useLocation } from 'react-router-dom';

const RuleGroupsForm = ({
  configData,
  formData,
  stateData,
  staticData,
  eventHandler,
}: any) => {
  const { formProps, saveButtonProps } = formData;
  const { ruleGroupDate, saveLoading } = stateData;
  const { type: pageType, groupHasRules } = staticData;
  const { onFinishHandler } = eventHandler;
  const { disabled } = configData;
  const t = useTranslate();
  const { ruleType } = useRulesDropdown();
  const location = useLocation();
  const hasShow = location.pathname.toLowerCase().includes('show');

  const activeStatus = [
    { label: t('rules.ruleActive'), value: true },
    { label: t('rules.ruleInactive'), value: false },
  ];
  const initialValues = {
    rule_group_is_active: true,
    rule_group_list: [
      {
        rule_group_id: null,
        execution_order: null,
      },
    ],
  };

  const isValuesPresent = formProps?.initialValues?.results || initialValues;
  console.log(groupHasRules, 'groupHasRules');

  return (
    <Form
      {...formProps}
      onFinish={onFinishHandler}
      initialValues={isValuesPresent}
      disabled={pageType === 'Show' || disabled}
      size="large"
      layout="vertical"
    >
      {/* <CustomBadge label={t('ruleGroup.ruleGroupDetails')} number={1} /> */}
      <Row gutter={16} className="">
        <Col xs={24} md={12} lg={12}>
          <TextInput
            label={t('ruleGroup.ruleGroupName')}
            name="rule_group_name"
            required={true}
            message={t('ruleGroup.messages.ruleGroupName')}
            placeholder={t('ruleGroup.messages.ruleGroupName')}
            disabled={pageType === 'Show'}
            rules={{
              pattern: regex.nameCheck,
              message: t('errorMessages.ruleGroupNameValidMsg'),
            }}
          />
        </Col>
        {/* </Row>
      <Row gutter={16} className="mb-4 "> */}
        <Col xs={24} md={12} lg={12}>
          <RangeInput
            label={t('ruleGroup.ruleGroupDate')}
            name="rule_group_date"
            required={true}
            message={t('ruleGroup.messages.ruleGroupDate')}
            format={constants.dateFormat}
            disabledDate={(current) => disabledDate(current, ruleGroupDate)}
            disabled={pageType === 'Show'}
          />
        </Col>
        {/* </Row>
      <Row gutter={16} className="mb-4 "> */}
        <Col xs={24} md={12} lg={12}>
          <DropdownInput
            label={t('rules.ruleType')}
            name="rule_type"
            required={true}
            optionList={ruleType}
            message={t('rules.messages.ruleType')}
            placeholder={t('rules.messages.ruleType')}
            disabled={
              pageType === 'Show' || (groupHasRules && groupHasRules > 0)
            }
          />
        </Col>
        {/* </Row>
      <Row> */}
        <Col xs={24} sm={24} lg={24}>
          <TextAreaInput
            label={t('ruleGroup.ruleGroupDescription')}
            name="rule_group_description"
            message={t('ruleGroup.messages.ruleGroupDescription')}
            placeholder={t('ruleGroup.messages.ruleGroupDescription')}
            rows={4}
            required={false}
            disabled={pageType === 'Show'}
          />
        </Col>
        {/* </Row>
      <Row gutter={16} className="mb-4"> */}
        <Col xs={24} sm={24} lg={12}>
          <label className="floating-label">{t('common.status')}</label>
          <SegmentInput
            className=""
            name="rule_group_is_active"
            optionList={activeStatus}
            disabled={pageType === 'Show'}
          />
        </Col>
      </Row>
      {!hasShow ? (
        <div className="flex justify-end">
          <SaveButton
            icon={false}
            className="mb-4 min-w-[100px]"
            {...saveButtonProps}
            disabled={pageType === 'Show'}
            loading={saveLoading}
          >
            {t('buttons.saveRuleGrp')}
          </SaveButton>
        </div>
      ) : null}
    </Form>
  );
};

export default RuleGroupsForm;
